
import NewSkeletonBox from '~/components/common/loading/skeleton/NewSkeletonBox.vue'

export default {
  name: 'MainHomeSkeleton',
  components: {
    NewSkeletonBox
  },
  data () {
    return {
      categoryChipCount: 11
    }
  }
}
